export default __webpack_public_path__ + "static/media/wall street for DM.9a71457d.svg";